var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719107391970,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12998,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.010667 170.666667C230.997333 170.666667 42.666667 331.178667 42.666667 398.677333c0 11.52-0.682667 41.344 109.354666 381.312C165.973333 823.509333 204.8 853.333333 248.021333 853.333333h631.978667c27.306667 0 52.821333-11.178667 72.021333-32A114.773333 114.773333 0 0 0 981.333333 734.677333l-24.021333-289.365333a113.92 113.92 0 0 0-30.634667-67.968C867.669333 315.178667 688 170.666667 292.010667 170.666667zM257.28 360.021333h109.354667c106.837333 0 109.312 87.125333 109.312 103.978667 0 70.997333-41.642667 90.496-49.322667 94.677333l58.666667 139.989334v2.688H411.989333L359.978667 577.28h-33.28v123.989333H257.28z m294.698667 0h105.301333c109.525333 0 109.354667 77.482667 109.354667 93.312 0 53.674667-35.157333 69.973333-42.666667 73.344 8.661333 2.474667 46.634667 13.994667 46.634667 74.666667 0 33.152-9.472 100.010667-105.301334 100.010667h-113.322666zM326.613333 417.28v102.656h38.698667c36.821333 0 41.301333-35.328 41.301333-50.645333 0-7.850667-0.64-52.010667-39.978666-52.010667z m294.698667 0v85.333333h35.968c36.693333 0 40.021333-27.648 40.021333-41.344 0-43.306667-26.026667-43.946667-40.021333-43.946666z m0 136.021333v90.666667h43.946667c37.845333 0 37.376-37.674667 37.376-43.989333 0-14.506667-2.346667-46.677333-36.010667-46.677334z",
    fill: "#333",
    "p-id": 12999
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRb);
export default __webpack_public_path__ + "static/media/rb.84fe497b3567436d97a36a4f17440270.svg";
export { ForwardRef as ReactComponent };